import SignInNavBarBack from "../../../components/layout/navigation/SignInNavBarBack/SignInNavBarBack";
import "./SignUpCreateAccount.css";
import BenevvTextField from "components/forms/BenevvTextField/BenevvTextField";
import BenevvSubmitField from "components/forms/BenevvSubmitField/BenevvSubmitField";
import Slide from '@mui/material/Slide';
import * as AuthServiceApi from 'apis/AuthServiceApi';
import React, {useState} from "react";
import {updateSignUpScreen} from "store/ui/signUpScreen/signUpScreen.slice";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {GreyTextBold, GreyTextLight, RedTextBold} from "components/text/Text";

function SignUpCreateAccount() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const user = await AuthServiceApi.registerUser({
      Name: fullName,
      Email: email,
      Password: password
    });
    navigate("/org/home");
  }

  return (
    <div className={'sign-up-right-container'}>
      <SignInNavBarBack screen={'SignUpThankYouScreen'}/>
      <Slide direction="left" in={true} mountOnEnter unmountOnExit>
        <div className={'create-account'}>
          <h1> Create Account </h1>
          <form action={"#"} onSubmit={onSubmit} className={'sign-up-form'}>
            <BenevvTextField htmlFor={'fullName'} labelText={'Full name*'} placeholder={'Enter full name'}
                             required={true} setTextField={setFullName}/>
            <BenevvTextField htmlFor={'email'} labelText={'Email address*'} placeholder={'Enter email address'}
                             required={true} email={false} setTextField={setEmail}/>
            <BenevvTextField htmlFor={'password'} labelText={'Password*'} placeholder={'Enter password'} required={true}
                             password={true} setTextField={setPassword}/>
            <div className={'already-have-an-account-text'}>
              <GreyTextLight> Already have an account?&nbsp;</GreyTextLight>

              <RedTextBold onClick={() => dispatch(updateSignUpScreen('SignInScreen'))}>Sign In</RedTextBold>
            </div>
            <BenevvSubmitField value={'Sign Up'} className={'create-account-submit'}/>
          </form>
        </div>
      </Slide>

    </div>
  )
}

export default SignUpCreateAccount;
